const initialState = {
    data:[],
    booking:[],
};


const SELECT_TAB = 'SELECT_PACK';
export const createSelectPackage = (data) => ({
    type: SELECT_TAB,
    data: data
});

export const bookSelect = (data) => ({
    type: 'SELECT_BOOK',
    data: data
});

export const packsel =(state=initialState,action)=>{
  switch (action.type) {

        case SELECT_TAB:
            return {
                ...state,
                data: action.data
            };

        case 'SELECT_BOOK':
              return{
                ...state,
                data:action.data
              };
        default:
            return state;
}
}



// WEBPACK FOOTER //
// ./src/reducers.js